import { get } from 'lodash'
import { debounce } from 'throttle-debounce'
import * as React from 'react'
import { connect } from 'react-redux'

import { setViewportSize } from 'embed/actions'
import { MultiProductState } from 'embed/reducers'

export interface ViewportSizeProviderDispatchProps {
  dispatchSetViewportSize: (height: number, width: number) => void
}

interface ViewportSizeProviderStoreProps {
  height: number
  width: number
}

type Props = ViewportSizeProviderDispatchProps & ViewportSizeProviderStoreProps

const ViewportSizeProvider: React.FC<Props> = ({ dispatchSetViewportSize, height, width }) => {
  const updateViewportSize = React.useCallback(() => {
    const { innerHeight, innerWidth } = window
    if (width !== innerWidth || height !== innerHeight) {
      dispatchSetViewportSize(innerHeight, innerWidth)
    }
  }, [dispatchSetViewportSize, height, width])

  const handleWindowResize = debounce(500, true, updateViewportSize)

  React.useEffect(() => {
    handleWindowResize()
    window.addEventListener('resize', handleWindowResize)

    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  return null
}

const mapDispatchToProps = (dispatch): ViewportSizeProviderDispatchProps => ({
  dispatchSetViewportSize: (height, width) => dispatch(setViewportSize(height, width)),
})

const mapStateToProps = (state: MultiProductState): ViewportSizeProviderStoreProps => ({
  height: get(state, 'ui.viewport.height'),
  width: get(state, 'ui.viewport.width'),
})

export default connect(mapStateToProps, mapDispatchToProps)(ViewportSizeProvider)
